import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { SocialStreamApiRequest, SocialStreamCatalogs } from './socialStreamApiRequestHelper'

Vue.use(Vuex)

export interface SocialStreamCatalogsState {
    dataLoading: boolean,
    data: {
        socialStreamCatalogs: SocialStreamCatalogs,
    }
}

const getInitialState = (): SocialStreamCatalogsState => ({
    dataLoading: true,
    data: {
        socialStreamCatalogs: {
            productsCatalogId: '',
            productsCatalogName: '',
            instagramPostsCatalogId: '',
            instagramPostsCatalogName: '',
        }
    }
})

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setProductsCatalogId(state: SocialStreamCatalogsState, productsCatalogId: string) {
      state.data.socialStreamCatalogs.productsCatalogId = productsCatalogId
    },
    setInstagramPostsCatalogId(state: SocialStreamCatalogsState, instagramPostsCatalogId: string) {
      state.data.socialStreamCatalogs.instagramPostsCatalogId = instagramPostsCatalogId
    },
    setInitialState(state: SocialStreamCatalogsState){
        state.dataLoading = false,
        state.data.socialStreamCatalogs = {
            productsCatalogId: '',
            productsCatalogName: '',
            instagramPostsCatalogId: '',
            instagramPostsCatalogName: '',
        }
    },
    setDataLoading(state: SocialStreamCatalogsState, dataLoading: boolean) {
        state.dataLoading = dataLoading
    }
  },
  actions: {
    updateProductsCatalogId(context: any, productsCatalogId: string) {
      context.commit('setProductsCatalogId', productsCatalogId)
    },
    updateInstagramPostsCatalogId(context: any, instagramPostsCatalogId: string) {
      context.commit('setInstagramPostsCatalogId', instagramPostsCatalogId)
    },
    storeSocialStreamCatalogs(context: any, configId: string) {
            
      const storeResponse = SocialStreamApiRequest.storeSocialStreamCatalogs(configId, context.state.data.socialStreamCatalogs)

      return storeResponse
        .then((response: AxiosResponse<SocialStreamCatalogs>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('socialStream.catalogs.storeError'), { root: true })
          throw error
        })
    },
    getSocialStreamCatalogs(context: any, configId: string) {
        if(typeof configId === 'undefined'){
            return
        }
        SocialStreamApiRequest.getSocialStreamCatalogs(configId).then(results => {
            context.commit('setProductsCatalogId', results.data.productsCatalogId)
            context.commit('setInstagramPostsCatalogId', results.data.instagramPostsCatalogId)
            context.commit('setDataLoading', false)
        })
    }

  }
})
